/**
 * Main Dashboard Layout Component
 *
 * Uses SidebarProvider + SidebarInset from the sidebar primitives.
 * The sidebar handles its own mobile Sheet overlay, keyboard shortcut (Cmd+B),
 * and localStorage persistence automatically.
 */

import React from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { AppSidebar } from './Sidebar'
import { Header } from './Header'
import { SidebarProvider, SidebarInset } from '../ui/sidebar'

export const Layout: React.FC = () => {
  const location = useLocation()

  // Conversations page uses full width, others use constrained width
  const isConversationsPage = location.pathname === '/dashboard/conversations'

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <Header />
        <div className="flex-1 overflow-auto">
          <div
            className={
              isConversationsPage
                ? 'w-full px-4 py-2'
                : 'w-full px-4 sm:px-6 lg:px-8 py-6'
            }
          >
            <Outlet />
          </div>
        </div>
      </SidebarInset>
    </SidebarProvider>
  )
}
